import React, { Component } from 'react';
import './profile.style.css';
import UserContext from '../../utils/userContext'
import axios from 'axios'
import {
    Link, Redirect
} from 'react-router-dom'

import { FeedCard, SkeletonFeed } from '../feed-container/feed-container.component';
import UserProfileSideMenu, { ProfileSideMenu } from '../profile-card/profile-card.component';

const EachUserPost = (props) => {
    const onDeletePost = () => {
        var self = this;

        axios({
            method: 'delete',
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts/`,
            data: { "contentId": props.postData.contentId },
            headers: {
                'Content-Type': 'multipart/form-data',


            }
        })
            .then(function (response) {
                props.updateUserPost(response.data.postData)
            })
            .catch(function (response) {
                // self.setState({ firstQuery: false })
            });
    }

    return (
        // <div className="content-wrap">
        <div className="card-wrap">
            <div className="content-card">
                <div className="action-user-post-segment">
                    <span className="delete-manage-post" onClick={onDeletePost}>
                        Delete
                    </span>
                    <Link to={`edit/${props.postData.path}`}>
                        <span className="edit-manage-post">
                            Edit
                        </span>
                    </Link>
                </div>
                <div className="title-manage-post">
                    {props.postData.title}&nbsp;{props.postData.status === "draft" ? <span className="draft-status">Draft</span> : ""}
                </div>
            </div>
        </div>
        // </div>
    )
}

export default class Profile extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            userPost: [],
            page: 0,
            loadMoreStatus: "loading",
            firstPostsQuery: false

        };

        this.handleScroll = this.handleScroll.bind(this)
    }

    updateUserPost(posts) {
        this.setState({ userPost: posts })
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }


    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        this.getPosts()

    }

    getPosts() {
        const limit = 15
        const page = this.state.page
        var self = this;

        axios({
            method: 'get',
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts/user/${this.props.match.params.authorName}?page=${page}&limit=${limit}`,
            headers: {
                'Content-Type': 'multipart/form-data',


            }
        })
            .then(function (response) {
                // self.setState({ userPost: response.data })

                if (response.data.length === 0) {
                    if (self.state.page === 0) {
                        // console.log("len0page0")
                        self.setState({ userPost: response.data, loadMoreStatus: "empty", firstPostsQuery: true })
                    } else {
                        // console.log("len0page+")
                        self.setState({ loadMoreStatus: "empty" })
                    }

                }
                else if (self.state.page === 0) {
                    // console.log("page0")
                    self.setState({ userPost: response.data, firstPostsQuery: true, page: 1, loadMoreStatus: "readyLoad" })
                } else {
                    // console.log("page+")
                    self.setState(prevState => ({
                        userPost: [...prevState.userPost.concat(response.data)],
                        page: self.state.page + 1,
                        loadMoreStatus: "readyLoad"
                    }))
                }

            })
            .catch(function (response) {
                // console.log("nope")
            });
    }

    handleScroll(event) {

        if (document.documentElement.scrollHeight - (window.pageYOffset + document.documentElement.clientHeight) < 625) {
            if (this.state.loadMoreStatus === "readyLoad") {
                this.setState({ loadMoreStatus: "loading" })
                this.getPosts()

            }

        }

    }

    render() {

        return (
            <div>
                <div className="content-wrap manage-post-wrap inner-bg-color">
                    <div className="blog-feed-wrap">
                        <div className="feed-wrap">
                            <div className="feed-header">บทความของ <span style={{ color: '#FFC000', fontWeight: 'bold' }}>{this.props.match.params.authorName}</span></div>

                            {this.state.firstPostsQuery ?
                                this.state.userPost.map((post, i) => <FeedCard key={i} post={post} />)
                                :
                                <>
                                    <SkeletonFeed />
                                    <SkeletonFeed />
                                    <SkeletonFeed />
                                    <SkeletonFeed />
                                    <SkeletonFeed />
                                </>
                            }

                            {(this.state.loadMoreStatus === "empty" || this.state.loadMoreStatus < 5) && this.state.firstPostsQuery ? <EmptyNewFeed /> : ""}
                        </div>
                    </div>
                    <div className="content-suggest-bar pt-15 pr-10">
                        <UserProfileSideMenu nicename={this.props.match.params.authorName} />
                    </div>
                </div>

            </div>
        )
    }

}


const EmptyNewFeed = (props) => {
    return (

        <div className="feed-card">
            <div className="feed-empty-quote">ไม่พบบทความเพิ่มเติมของผู้ใช้ท่านนี้แล้ว</div>
        </div >

    )
}
